import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import BrandedMissionName from "../common/BrandedMissionName";

const navLinkClass =
  (isTransparent, isMobileMenu) =>
  ({ isActive }) =>
    [
      `relative rounded-full border text-sm font-medium transition-all duration-200 ${
        isMobileMenu ? "px-4 py-2 text-center" : "px-3 py-1.5"
      }`,
      isActive
        ? "bg-accent text-white border-accent shadow-sm -translate-y-0.5"
        : isTransparent
          ? "bg-white/10 text-white border-white/20 hover:bg-white/20 hover:text-white hover:-translate-y-0.5 active:translate-y-0"
          : "bg-white text-black border-transparent hover:border-transparent hover:bg-accent/10 hover:text-accent hover:-translate-y-0.5 active:translate-y-0",
    ].join(" ");

const Header = () => {
  const { pathname } = useLocation();
  const [isAtTop, setIsAtTop] = useState(true);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setIsAtTop(window.scrollY < 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [pathname]);

  const isTransparent = pathname === "/" && isAtTop;

  return (
    <header
      className={`left-0 right-0 px-4 md:px-8 py-4 transition-all duration-300 ${
        isTransparent
          ? "absolute top-0 z-50 bg-transparent border-b border-transparent"
          : "sticky top-0 z-50 bg-white/95 backdrop-blur border-b border-muted/70"
      }`}
    >
      <div className="w-full flex items-center justify-center gap-6 max-w-7xl mx-auto">
        <h1 className="min-w-0 pr-2 text-sm font-semibold leading-snug tracking-wide sm:text-base md:text-lg text-center">
          <BrandedMissionName
            variant="title"
            gradient={!isTransparent}
            className={isTransparent ? "text-white drop-shadow" : ""}
          />
        </h1>
      

      {/* <button
          type="button"
          className={`md:hidden inline-flex h-10 w-10 items-center justify-center rounded-md ${
            isTransparent ? 'text-white bg-black/25' : 'text-black bg-black/5'
          }`}
          onClick={() => setIsMobileMenuOpen((prev) => !prev)}
          aria-label="Toggle navigation menu"
          aria-expanded={isMobileMenuOpen}
        >
          <span className="sr-only">Toggle navigation menu</span>
          {isMobileMenuOpen ? (
            <span className="relative h-4 w-4">
              <span className="absolute left-0 top-1/2 h-0.5 w-4 -translate-y-1/2 rotate-45 bg-current" />
              <span className="absolute left-0 top-1/2 h-0.5 w-4 -translate-y-1/2 -rotate-45 bg-current" />
            </span>
          ) : (
            <span className="flex flex-col gap-1">
              <span className="block h-0.5 w-4 bg-current" />
              <span className="block h-0.5 w-4 bg-current" />
              <span className="block h-0.5 w-4 bg-current" />
            </span>
          )}
        </button> */}
      </div>

      {/* <nav className="hidden md:flex flex-wrap items-center gap-2">
          <NavLink to="/" className={navLinkClass(isTransparent, false)} end>
            Home
          </NavLink>
          <NavLink to="/about" className={navLinkClass(isTransparent, false)}>
            About
          </NavLink>
          <NavLink to="/awards" className={navLinkClass(isTransparent, false)}>
            Awards
          </NavLink>
          <NavLink to="/videos" className={navLinkClass(isTransparent, false)}>
            Videos
          </NavLink>
          <NavLink
            to="/dhm-works"
            className={navLinkClass(isTransparent, false)}
          >
            DHM Works
          </NavLink>
          <NavLink
            to="/support-us"
            className={navLinkClass(isTransparent, false)}
          >
            Support Us
          </NavLink>
          <NavLink to="/contact" className={navLinkClass(isTransparent, false)}>
            Contact
          </NavLink>
        </nav>*/}

      {/* {isMobileMenuOpen && (
        <nav
          className={`absolute left-4 right-4 top-full z-50 mt-2 grid gap-2 rounded-xl p-3 shadow-lg md:hidden ${
            isTransparent
              ? 'border border-white/20 bg-black/35 backdrop-blur'
              : 'border border-muted/70 bg-white'
          }`}
        >
          <NavLink to="/" className={navLinkClass(isTransparent, true)} end>
            Home
          </NavLink>
          <NavLink to="/about" className={navLinkClass(isTransparent, true)}>
            About
          </NavLink>
          <NavLink to="/awards" className={navLinkClass(isTransparent, true)}>
            Awards
          </NavLink>
          <NavLink to="/videos" className={navLinkClass(isTransparent, true)}>
            Videos
          </NavLink>
          <NavLink
            to="/dhm-works"
            className={navLinkClass(isTransparent, true)}
          >
            DHM Works
          </NavLink>
          <NavLink
            to="/support-us"
            className={navLinkClass(isTransparent, true)}
          >
            Support Us
          </NavLink>
          <NavLink to="/contact" className={navLinkClass(isTransparent, true)}>
            Contact
          </NavLink>
        </nav>
      )} */}
    </header>
  );
};

export default Header;
